import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {userLocale} from '../../../store/actions/locale';
import {
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';
import {ENGLISH_LOCALE, ROMANIAN_LOCALE} from '../../../languages';
import {closeMenuMobile} from "../../../helpers/menu";

function SelectLanguageComponent(props) {
  return (
    <Fragment>
      <UncontrolledDropdown nav inNavbar>
        <DropdownToggle nav caret>
          <span className="lang-code">{props.lang}</span>
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={() => {
            closeMenuMobile();
            props.userLocale(ROMANIAN_LOCALE)
          }}>
            <FormattedMessage id="components.pages.static.header.ro_language"/>
          </DropdownItem>
          <DropdownItem onClick={() => {
            closeMenuMobile();
            props.userLocale(ENGLISH_LOCALE)
          }}>
            <FormattedMessage id="components.pages.static.header.en_language"/>
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </Fragment>
  )
}

const mapStateToProps = state => ({
  lang: state.locale.lang
});

const SelectLanguage = connect(mapStateToProps, {userLocale})(SelectLanguageComponent)
export {SelectLanguage, SelectLanguageComponent}
